import api from 'Application/api/api';

const updateDriverLicenseBackData = (
    driverLicenseControlId,
    data,
    cancelToken = null,
) =>
    api.post(
        `/measures/vehicles/driver-licenses/controls/${driverLicenseControlId}/driver-license/update-back-data`,
        data,
        {
            cancelToken,
        },
    );

export default updateDriverLicenseBackData;
